import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SelectedSuppliersReducer(state = initialState.selectedSuppliers, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_SUPPLIERS_SUCCESS:
      return action.selectedSuppliers;
    default:
      return state;
  }
}
